// 商店街エリアラベル: 店舗ラベル管理(/settings/shop-label)のプリセットとして登録される UserTagGroup の name_en
export const SHOPPING_DISTRICT_AREA_LABEL_NAME_EN = 'Shopping District Area';

// 業種:大分類ラベル: 店舗ラベル管理(/settings/shop-label)のプリセットとして登録される UserTagGroup の name_en
export const INDUSTRY_MAJOR_CATEGORY_LABEL_NAME_EN = 'Industry:Major Category';

// 発行体組織コード抽出時に除外する特殊組織
export const EXCLUDED_ISSUER_ORG_CODE = 'pocketchange';

// 店舗ラベル管理のプリセット候補。
// 管理者が「有効化」した時に初めて UserTagGroup として登録される。
// name_en は登録済みグループとの照合キーとして使用するため変更不可。
export type PresetGroup = {
  name_en: string;
  name_ja: string;
};

export const PRESET_GROUPS: PresetGroup[] = [
  { name_en: SHOPPING_DISTRICT_AREA_LABEL_NAME_EN, name_ja: '商店街エリア' },
  { name_en: INDUSTRY_MAJOR_CATEGORY_LABEL_NAME_EN, name_ja: '業種：大分類' },
];

// グループがプリセット由来かどうかを判定（name_en で照合）
export const isPresetGroupNameEn = (nameEn: string): boolean =>
  PRESET_GROUPS.some((preset) => preset.name_en === nameEn);
